import { Component, effect, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { subscribeToLangChange } from './core/helpers/lang-change.helper';
import { Subscription } from 'rxjs';
import { GaLoaderService } from './core/services/ga-loader.service';
import { UserService } from './features/user/service/user.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TranslateModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  #gaLoader = inject(GaLoaderService);
  #userService = inject(UserService);
  #langChangeSub!: Subscription;

  title = 'valvur-admin';

  constructor(private translate: TranslateService) {
    translate.addLangs(['en', 'et', 'ru']);
    translate.setDefaultLang('en');
    const browserLang = translate.getBrowserLang() ?? 'en';
    const defaultLanguage = translate.getDefaultLang();
    translate.use(
      browserLang.match(/en|et|ru/) ? browserLang : defaultLanguage
    );
    this.#gaLoader.load();

    effect(() => {
      const settings = this.#userService.settings();
      if (settings?.language) {
        this.translate.use(settings.language);
      }
    });
  }

  ngOnInit(): void {
    this.#langChangeSub = subscribeToLangChange(this.translate, () => {});
  }

  ngOnDestroy() {
    this.#langChangeSub.unsubscribe();
  }
}
